import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=2d408f72&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=2d408f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d408f72",
  null
  
)

export default component.exports